import React from 'react';
import { Field, ErrorMessage, useFormikContext } from 'formik';
import { Box, TextField, Typography } from "@mui/material";

export default function JobDetailsStep() {
    const { errors, touched, values } = useFormikContext();
    const fieldSx = { '& .MuiOutlinedInput-root': { borderRadius: '12px' } };

    return (
        <Box pt={2}>
            <Field
                as={TextField}
                fullWidth
                label="Job Title"
                name="title"
                helperText={
                    <Box component="span" sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span><ErrorMessage name="title" /></span>
                        <Typography variant="caption" sx={{ ml: 'auto' }}>
                            {`${values.title.length} / 75`}
                        </Typography>
                    </Box>
                }
                error={touched.title && Boolean(errors.title)}
                sx={fieldSx}
                inputProps={{ maxLength: 75 }}
            />
            <Box mt={3} />
            <Field
                as={TextField}
                fullWidth
                multiline
                rows={8}
                label="Description"
                name="description"
                helperText={
                    <Box component="span" sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span><ErrorMessage name="description" /></span>
                        <Typography variant="caption" sx={{ ml: 'auto' }}>
                            {`${values.description.length} / 500`}
                        </Typography>
                    </Box>
                }
                error={touched.description && Boolean(errors.description)}
                sx={fieldSx}
                inputProps={{ maxLength: 500 }}
            />
        </Box>
    );
}
